import { NgModule } from '@angular/core';
import { FormlySelectOptionsPipe } from './select-options.pipe';

@NgModule({
  declarations: [FormlySelectOptionsPipe],
  exports: [FormlySelectOptionsPipe],
})
export class FormlySelectModule {}
